export default{
    spacings: window.innerWidth>899?[0,16,32,64,120]:[0,16,24,48,64],
}